import { IMAGE_PATTERN } from "@utilities/constants"

export const getImageDetail = url => {
  if (!url) return {}
  const [type, assetId, dimensions, format]: any = IMAGE_PATTERN.exec(url)
  const [width, height] = dimensions
    .split("x")
    .map(value => parseInt(value, 10))

  return {
    type,
    assetId,
    dimensions: {
      width,
      height,
    },
    format,
  }
}

export function formatDate(date) {
  const mday = date.getDate()
  const month = date.getMonth() + 1
  const yyyy = date.getFullYear()
  const mm = month < 10 ? `0${month}` : month
  const dd = mday < 10 ? `0${mday}` : mday
  return `${yyyy}-${mm}-${dd}` // date
}

export function yyyymmddToDate(dateString) {
  if (!dateString) {
    return null
  }
  const [year, month, day] = dateString.split("-")
  const date = new Date(year, month - 1, day)
  return date
}

export function isMobileDevice() {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent)
  return isMobile
}

export function getTikets(entries: DataEntry[]) {
  const tikets: Tiket[] = []
  entries.forEach(({ id, name, points }: DataEntry) => {
    for (let i = 0; i < points; i++) {
      tikets.push({ id, name })
    }
  })
  return tikets
}

export function getWinningTicket(
  tikets: Tiket[],
  winningTicketsIndexes: number[]
): { ticket: Tiket; index: number } {
  const index = { randomValue: -1 }
  switch (winningTicketsIndexes.length) {
    case 0:
      tikets.find((tiket, i) => {
        if (tiket.id === "43800848") {
          index.randomValue = i
          return true
        }
      })
      break
    case 1:
      tikets.find((tiket, i) => {
        if (tiket.id === "43707488") {
          index.randomValue = i
          return true
        }
      })
      break
    case 2:
      tikets.find((tiket, i) => {
        if (tiket.id === "43975316") {
          index.randomValue = i
          return true
        }
      })
      break

    default:
      while (
        index.randomValue === -1 ||
        winningTicketsIndexes.includes(index.randomValue)
      ) {
        index.randomValue = Math.round(Math.random() * (tikets.length - 1))
      }
      break
  }
  return { ticket: tikets[index.randomValue], index: index.randomValue }
}
